import { TFunction } from 'i18next';
import type {
  PartnerStudentEnrollmentRow,
  PartnerStudentFilterKey,
} from 'types/partnerEnrollment';

export const PARTNER_STUDENT_FILTER_GROUP_KEY = 'status';

export const PARTNER_SUBSCRIPTIONS_ROUTE_NAME = 'partner:subscriptions';

export const PARTNER_LIVECLASS_SCHEDULE_ROUTE_NAME =
  'partner:liveclass:schedule';

export const PARTNER_STUDENT_FILTER_URL_KEY = 'status';

export const PARTNER_LIVECLASS_SCHEDULE_USER_URL_KEY = 'user_uuid';

export const PARTNER_STUDENT_FILTER_KEYS: PartnerStudentFilterKey[] = [
  'active',
  'future',
  'unscheduled',
  'scheduled',
];

export function isPartnerStudentFilterKey(
  key: string,
): key is PartnerStudentFilterKey {
  return PARTNER_STUDENT_FILTER_KEYS.includes(key as PartnerStudentFilterKey);
}

export type PartnerStudentFilterConfiguration = {
  key: PartnerStudentFilterKey;
  title: string;
  validateEntry: (enrollment: PartnerStudentEnrollmentRow) => boolean;
};

export const getFilterConfigurations = (
  t: TFunction = (str: string) => str,
): PartnerStudentFilterConfiguration[] => [
  {
    key: 'active',
    title: t('Active subscription'),
    validateEntry: (enrollment) =>
      enrollment.status === 'scheduled' || enrollment.status === 'unscheduled',
  },
  {
    key: 'future',
    title: t('Future subscription'),
    validateEntry: (enrollment) => enrollment.status === 'unavailable',
  },
  {
    key: 'unscheduled',
    title: t('Unscheduled'),
    validateEntry: (enrollment) => enrollment.status === 'unscheduled',
  },
  {
    key: 'scheduled',
    title: t('Scheduled'),
    validateEntry: (enrollment) => enrollment.status === 'scheduled',
  },
];

export function enrollmentMatchesFilter(
  enrollment: PartnerStudentEnrollmentRow,
  key: PartnerStudentFilterKey,
): boolean {
  const config = getFilterConfigurations().find((filter) => filter.key === key);
  return config ? config.validateEntry(enrollment) : false;
}
